export const PEI_ANNUAL_RETURNS_MENU_LINKS = ['/SwdaPeiAnnualReturns']
